const tableSelectionGetArrowBoxClasses = function() {
	return 'ae-arrow-box ae-arrow-box-bottom';
};

const SelectionGetArrowBoxClasses = {
	table: tableSelectionGetArrowBoxClasses,
};

export default SelectionGetArrowBoxClasses;
